<template>
  <div id="episodeListingContainer">
    <div class="mainLayout" v-if="checkSeries && dataFetched">
      <div class="EmptyContainer" v-if="seasons.length == 0">
        <EptyBin></EptyBin>
        <p> {{$t("No contents found")}} </p>
      </div>
      <div v-else class="content-container">
        <div class="mainLayoutSeason">    
          <CustomSelect
            :options="seasons"
            width="150"
            @onSelectChange="onItemSelected"
          />
        </div>      
        <!-- <Grid :contents="episodes" :isScrollable="isScrollable" @loadMore="nextPageDataset()"></Grid> -->
        <div class="gridMainLayout">

          <!-- <h1 style="text-align: center;color: #FFFFFF;">{{ episodes.length }}</h1> -->
          <ul :class="[localDisplayLang === 'ara' ? 'episodeCardsAra' : 'episodeCards']" class="gridContainer landscape">
            <li class="gridCardWrapper" v-for="(episode, index) in episodes" :key="episode.objectid" @click="playContent(episode, index)">
              <div class="gridCardLayout">
                <div class="gridPosterLayout">
                  <img :src="getPoster(episode)" class="episodePoster" :alt="episode.title" decoding="async"/>
                  <div class="play-img">
                    <img src="@/assets/icons/Ic_Play1.svg" alt="" width="36" height="36" decoding="async"/>
                  </div>
                </div>
                <div v-if="isObjectTag(episode) && pickTagForContent(episode)" :class="[localDisplayLang === 'ara' ? 'episodeTagRight' : 'episodeTag']">
                  <img src="@/assets/icons/Premium_1_scg.svg" alt="crown" decoding="async">
                </div>
                <div class="gridContentLayout">
                  <div class="gridContentTitle">
                    <p :title="episode.title">
                      S{{ episode.seasonnum }} E{{ episode.episodenum }} : {{ episode.title }}
                    </p>
                  </div>
                  <div class="gridContentDetails">
                    <div class="main-info">
                      <div class="ua-rating" v-if="episode.advisory">
                        <p>{{ episode.advisory }}</p>
                      </div>
                      <div class="publish-year" v-if="episode.productionyear">
                        <p>{{ episode.productionyear }}</p>
                      </div>
                      <div class="duration" v-if="episode.duration">
                        <p>{{ calcTimeFormat(episode.duration) }}</p>
                      </div>
                      <div class="pgrating" v-if="episode.pgrating">
                        <p>{{ episode.pgrating }}</p>
                      </div>
                    </div>
                    <div class="main-genre">
                      <div class="sub-genre1" v-if="episode.category">
                        <p>{{ $t(episode.category) }}</p>
                      </div>
                      <div class="sub-genre2" v-if="episode.genre">
                        <p>{{ $t(episode.genre) }}</p>
                      </div>
                      <div class="sub-genre3" v-if="episode.contentlanguage.length > 0">
                        <p>{{ $t(episode.contentlanguage[0]) }}</p>
                      </div>
                    </div>
                  </div>
                  <p class="gridDescription" v-if="episode.shortdescription || episode.longdescription">
                    {{ getDescription(episode, 150) }}
                  </p>
                </div>
              </div>
            </li>
            <li v-if="isloading" class="gridCardWrapper" v-for="(episode, index) in 6" :key="index">
              <div class="gridCardLayout">
                <div class="gridPosterLayout loading"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else>
      <GridLayoutPlaceholder :displayType="'LANDSCAPE'"></GridLayoutPlaceholder>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";
import Redirection from "@/mixins/redirection.js";
import { getDatabase, ref, get, child } from "firebase/database";
import { getApp } from "firebase/app";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { store } from "@/store/store";
import { showSnackBar } from "@/utilities";

export default {
  props: {
    contentDetails: {
      type: Object,
    },

    playerInstance: {
      type: Object,
    },
		cbPlayerCall: {
			type: String
		}
  },
  data() {
    return {
      availabilities: [],
      subscriptions: [],
      purchases: [],
      filteredAvailabilities: [],
      playbackInitiated: false,
      pricemodel: [],
      dataFetched: false,
      seasonNum: 1,
      seasonCount: null,
      localDisplayLang: null,
      seasons: [],
      isMpegRequired: false,
      episodes: [],
      isloading: true,
      totalEpisodeCount: 0,
      episodePlayFromRoute: false,
      episodePaginatinInProgress: false,
			selectedCurrentEpisode: '',
      isActiveStatus: true,
      rentNowPriceModel: '',
      purchaseListData: '',
      rentPurchasedActive: false,
      userInfoDetails: [],
      currentEpisode: {},
      placeholder_lands: require('@/assets/placeholder-lands.svg'),
      isScrollable: false,
      storeCBLoadContent: '',
      seasonsData: {}
    };
  },

  watch: {
    purchaseList (val) {
      this.purchaseListData = val;
      // this.getPurchaseListCode();
    },
    subscriberid(val) {
      if (val) {
        this.getAvailabilityForAllContents(this.episodes);
      }
    },
    subscriptionList(val) {
      if (val.length > 0) {
        this.subscriptions = val;
        this.getAvailabilityForAllContents(this.episodes);
      }
      this.actGetLatestEpisode();
    },
    availabilityList(val) {
      if (Array.isArray(val) && val.length > 0) {
        this.availabilities = val;
        this.getAvailabilityForAllContents(this.episodes);
      }
    },

    episodes(val) {
      if (val) {
        this.getAvailabilityForAllContents(val);
      }

      // if (val.length > 0) {
      //   this.getAudioAndSubtitleLang(val[0]);
      // }
    },
  },
  computed: {
    ...mapGetters([
      "subscriberid",
      "availabilityList",
      "subscriptionList",
      "purchaseList",
      "appConfig",
      "getEpisodePaginationInProgress",
      "profileid",
      
    ]),
    checkSeries: function() {
      if (this.contentDetails.category == "MOVIE") {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    if (this.purchaseList) {
      this.purchaseListData = this.purchaseList;
    }

    eventBus.$on("event-callback-parentallock", (ParentalLockDataset) => {
      this.playContent(ParentalLockDataset[0], ParentalLockDataset[1], true)
    });

    try {
      this.userInfoDetails = localStorage.getItem("subscriberDetails") ? JSON.parse(localStorage.getItem("subscriberDetails")).data : [];
    } catch(err) {
      console.log(err)
    }

    
    console.log("fetchEpisodeList_created");
    this.episodes = [];
    this.seasons = [];
    //assigning availability list response.

    // this.isMpegRequired = this.checkMpegRequired();
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    
    this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;

    if (this.availabilityList !== undefined) {
      this.availabilities = this.availabilityList;
    }
    if (this.subscriptionList !== undefined) {
      this.subscriptions = this.subscriptionList;
    }
  },
  mounted() {
    this.$nextTick(async () => {
      this.episodes = [];
      this.seasons = [];
      
      await this.getSeasonCount();
      let payload = {
        objecttype: "SEASON",
        seriesid: this.contentDetails.objectid,
        pagesize: '30',
        page: '1',
      };
     let seasonCount =  store.dispatch("listContent", payload);
      console.log("this.episodes_nextTrick")
    });

    if(screen.height >= 1440) {
      this.debounce(this.nextPageDataset, 2000);
    }

    window.addEventListener("scroll", () => {

      let scrollHeight, totalHeight;
      scrollHeight = document.body.scrollHeight;
      totalHeight = window.scrollY + window.innerHeight;

      if (totalHeight >= scrollHeight) {
        this.debounce(this.nextPageDataset, 100);
      }
    });
    eventBus.$on("callAvailability", () => {
      this.getAvailabilityForAllContents(this.episodes);
    });
  },
  methods: {
    ...mapMutations([
      "setRegActiveDeeplink",
      "setSubscriptionList",
      "setAudioAndSubtitleLangState",
      "setEpisodePaginationInProgress",
      "setActivePlaylist"
    ]),
    ...mapActions(["getContent", "listContent", "authorizeCurrentStreamApi", "setCurrentStreamApi",  "availabilityDetail"]),
    getPurchaseListCode (contentId) {
      for(let list of this.purchaseListData) { 

       if ( (list.objectid).toLowerCase() == contentId) {
          return true;          
       }  
      }
      return false;
    },
    getPoster(content, type="LANDSCAPE") {
      if (content.posterurl) {
        return content.posterurl;
      }

      if (Array.isArray(content.poster)) {
        // Find poster with specified postertype and posterusage RAIL
        let poster = content.poster.find((element) => {
          return element.postertype === type && element.posterusage === "RAIL";
        });

        // If a valid poster is found, select quality in order: HD, SD, LOW, THUMBNAIL
        if (poster && Array.isArray(poster.filelist) && poster.filelist.length > 0) {
          let img = null;
          const qualityOrder = ["LOW", "SD", "HD", "THUMBNAIL"];
          for (let quality of qualityOrder) {
            const file = poster.filelist.find((f) => f.quality === quality);
            if (file) {
              img = file.filename;
              break;
            }
          }
          if (img) {
            return img;
          } else {
            if (type === "LANDSCAPE") {
              return this.placeholder_lands;
            } else if (type === "PORTRAIT") {
              return this.placeholder_port;
            } else if (type === "SQUARE") {
              return this.placeholder_sqare;
            }
          }
        }

        // Return placeholder if no poster is found
        if (type === "LANDSCAPE") {
          return this.placeholder_lands;
        } else if (type === "PORTRAIT") {
          return this.placeholder_port;
        } else if (type === "SQUARE") {
          return this.placeholder_sqare;
        }
      }

      if (content.inwatchlist) {
        return content.poster.landscape;
      } else if (content?.contentprovider === "CATCHUPTV" || content?.objecttype === "EPGPROGRAMME") {
        return content.thumbnail || this.placeholder_lands;
      } else if (content.thumbnail) {
        return content.thumbnail;
      } else {
        if (type === "LANDSCAPE") {
          return this.placeholder_lands;
        } else if (type === "PORTRAIT") {
          return this.placeholder_port;
        } else if (type === "SQUARE") {
          return this.placeholder_sqare;
        }
      }
    },
    pickTagForContent(content) {
      if (content && content.hasOwnProperty("objecttag")) {
        let tag = content.objecttag[0];
        let contenttags = this.appConfig.contentTags;
        if (this.localDisplayLang === "ara") {
          return contenttags.ar[`${tag}`];
        } else {
          return contenttags.en[`${tag}`];
        }
      }
    },
    async actGetLatestEpisode() {
      const progressSnapshot = await this.checkEpisodeContinueWatch();
      let progressData = progressSnapshot?.val() || {};
      // Find current content objectid in progressData
      let currentContentData = progressData[this.contentDetails.objectid];
      if (currentContentData && currentContentData.episodes) {
        const allSortEpi = Object.values(currentContentData.episodes).sort(
          (a, b) => b.updatedat - a.updatedat
        );
        this.selectedCurrentEpisode = allSortEpi[0];
      } else {
        this.selectedCurrentEpisode = this.episodes[0];
      }
      // Merge watched duration and duration into main episodes array
      if (this.selectedCurrentEpisode) {
        for (let episode of this.episodes) {
          if (episode.objectid === this.selectedCurrentEpisode.objectid) {
            episode.watchedduration = this.selectedCurrentEpisode.watchedduration;
            episode.duration = this.selectedCurrentEpisode.duration;
            this.selectedCurrentEpisode = episode;
            break;
          }
        }
        this.$emit('setCurrentEpisodeInformation', this.selectedCurrentEpisode);
        eventBus.$emit('currentEpisodeData', this.selectedCurrentEpisode);
      }
    },
    async checkEpisodeContinueWatch() {
      this.continueWatchContent = [];
      this.continueWatchData = [];
      this.detailPlaylist = [];
      this.finalPlaylist = [];
      this.completeEpisodeListing = [];
      this.continueData = [];

      if (this.subscriberid && this.profileid) {
        const db = getDatabase(getApp());
        const path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;
        const contentRef = ref(db, path);

        try {
          const snapshot = await get(contentRef);
          return snapshot;
        } catch (err) {
          console.error("Error fetching continue watch data:", err);
          return null;
        }
      } else {
        // No subscriber/profile, default to first episode
        this.selectedCurrentEpisode = this.episodes[0];
        this.$emit('setCurrentEpisodeInformation', this.selectedCurrentEpisode);
        eventBus.$emit('currentEpisodeData', this.selectedCurrentEpisode);
      }
    },
    isObjectTag(content) {
      if (content.hasOwnProperty("objecttag")) {
        if (Array.isArray(content.objecttag)) {
          return content.objecttag.length === 0 ? false : true;
        } else {
          return content.objecttag === null ? false : true;
        }
      }
    },
    nextPageDataset() {
      if (this.episodes.length < this.totalEpisodeCount && this.isloading == false) {
        this.isloading = true;        
        // this.isScrollable = true,
        this.fetchEpisodeList(this.contentDetails.objectid, this.seasonNum, 'nextPageDataset');
      }
    },
    debounce(method, delay) {
      clearTimeout(method._tId);
      method._tId = setTimeout(function() {
        method();
      }, delay);
    },
    checkMpegRequired() {
      let isMpegRequired = false;
      let videoTag = document.createElement("video");
      let platformOs = navigator.platform;

      if (videoTag.canPlayType("application/vnd.apple.mpegurl")) {
        if (platformOs.startsWith("Mac")) {
          isMpegRequired = true;
        }
      }

      return isMpegRequired;
    },
    getAvailabilityForAllContents(val) {
      val.forEach(async (element) => {
        if (this.subscriberid) {
          await this.getAvailability(element);
        }
        element.type = "inner";
      });
    },
    onItemSelected(obj) {
      this.seasonNum = obj.selectedItem['seasonnum'];
      this.isloading = true;
      this.episodes = [];
      console.log("season_listing_onItemSelected", this.episodes);
      this.totalEpisodeCount = 0;
      this.fetchEpisodeList(this.contentDetails.objectid, this.seasonNum, 'onItemSelected');
    },
    async getSeasonCount() {
      let payload = {
        objecttype: "SEASON",
        seriesid: this.contentDetails.objectid,
        pagesize: '100',
        page: '1',
      };
      store
      .dispatch("listContent", payload)
      .then((response) => {
        console.log("season_listing_response", response.data);
        if (response.reason) {
          this.episodeList = [];
          this.seasons = [];
        } else {
          this.seasonCount = response?.data?.totalCount;
          this.seasons = response?.data?.data;
          console.log(this.seasons, "seasons");
          this.seasonNum = this.seasons?.[0]?.['seasonnum'];
          this.isloading = true;
          this.episodes = [];
          this.totalEpisodeCount = 0;
          console.log("season_listing_getSeasonContents", this.episodes);
          this.fetchEpisodeList(this.contentDetails.objectid, this.seasonNum, 'getSeasonCount');
        }
      })
      .catch((error) => {
        console.log(error)
      });
      // eventBus.$emit("get-seasonnum-listing", payload);
    },
    fetchEpisodeList(seriesId, seasonNum, type) {
      let pageSize = this.appConfig.defaultpageSize;
      let pageNum = Math.floor(this.episodes.length / pageSize) + 1;
      let payload = {
        objecttype: "CONTENT",
        seriesid: seriesId,
        seasonnum: seasonNum,
        pagesize: pageSize,
        page: pageNum,
        displaylanguage: this.localDisplayLang,
      };
      this.episodePaginatinInProgress = true;
      store.dispatch("listContent", payload).then((response) => {
        if (response.data) {
          console.log("atlestttt", response)
          // eventBus.$emit("send-episode-list", response.data);
          this.dataFetched = true;
          setTimeout(() => {
            this.isloading = false;
          }, 100);
          if (!response?.data?.reason) {
            if (this.totalEpisodeCount == 0) {
              this.totalEpisodeCount = response?.data?.totalcount;
            };
            if (this.episodes.length < this.totalEpisodeCount) {
              let numOfNewEpisodes = response?.data?.data?.length;
              this.episodes = this.episodes.concat(response?.data?.data);
              if(this.seasons?.[this.seasonNum]){
                this.seasons[this.seasonNum]['episodesData'] = this.episodes;
              }
              this.setActivePlaylist(this.episodes || []);
              this.isScrollable = response?.data?.totalcount == this.episodes.length ? false : true;
              if (this.subscriberid || this.profileid) {
                // this.actGetLatestEpisode();
              } else {
                // this.$emit('totalEpisodeListCB', this.episodes);
                // this.selectedCurrentEpisode = this.episodes && this.episodes.length ? this.episodes[0] : null;
                // this.$emit('setCurrentEpisodeInformation', this.selectedCurrentEpisode);
              }
            }
          } else {
            this.episodes = [];
            this.totalEpisodeCount = 0;
            // this.$emit('totalEpisodeListCB', false)
          }

          this.getAvailabilityForAllContents(this.episodes);
        }
      }).catch((error) => console.log("episode-list-error", error));
    },
    async getAvailability(contentItem) {
      if (contentItem.hasOwnProperty("contentdetails") && contentItem.contentdetails.length > 0) {
        contentItem.isContentDetail = true;

        const { filteredAvailabilityList, packageDetails } = await this.determineContentPackageAvailabilityDetails(contentItem, this.availabilities);

        for (const availability of filteredAvailabilityList) {
          // 1. PLAN
          if (availability.pricemodel === "PLAN") {
            this.subscriptions = JSON.parse(localStorage.getItem("subscriptionDetails"));
            if (this.subscriberid && this.subscriptions.length > 0) {
              for (const subscription of this.subscriptions) {
                if (this.getDateForPlayback(subscription.nextbilling) && this.getDateForPlayback(subscription.nextbilling) < this.getTodaysDate()) continue;

                const hasAccess = subscription.availabilityset.includes(availability.availabilityid);
                if (hasAccess) {
                  contentItem.isDrmContent = true;
                  contentItem.videoType = "Content";
                  contentItem.playback_details = {
                    packageid: packageDetails.packageid,
                    availabilityid: availability.availabilityid,
                    drmscheme: packageDetails.drmscheme?.[0],
                    drmprovider: packageDetails?.drmprovider,
                  };
                  if (packageDetails?.[0]?.streamurl) {
                    contentItem.streamUrl = packageDetails[0].streamurl;
                  }
                  return; // Exit once valid plan is found
                }
              }
            }

          // 2. RENTAL or PAID
          } else if (this.subscriberid && (availability.pricemodel === "RENTAL" || availability.pricemodel === "PAID")) {
            let isEnablePlay = this.purchaseListData.some(list => list.objectid === contentItem.objectid);

            if (isEnablePlay) {
              contentItem.isDrmContent = true;
              this.isButtonEnable = true;
              contentItem.videoType = "Content";
              contentItem.playback_details = {
                packageid: packageDetails.packageid,
                availabilityid: availability.availabilityid,
                drmscheme: packageDetails.drmscheme?.[0],
                drmprovider: packageDetails?.drmprovider,
              };
              if (packageDetails?.[0]?.streamurl) {
                contentItem.streamUrl = packageDetails[0].streamurl;
              }
              return;
            }

            // Load price info if not purchased
            const res = await this.availabilityDetail(availability.availabilityid);
            const userCurrency = this.userInfoDetails.subscribercountry === 'IN' ? 'INR' : 'USD';

            const priceDetail = res.data.priceclassdetail.find(p => p.currency === userCurrency);
            if (priceDetail) {
              this.rentNowPriceModel = {
                planname: contentItem.title,
                amount: priceDetail.price,
                planid: priceDetail.priceclassid,
                priceclassid: priceDetail.priceclassid,
                availabilityid: availability.availabilityid,
                planinterval: res.data.licenseduration,
                currency: priceDetail.currency,
                rental: "PURCHASE",
                getPoster: this.getPoster(contentItem),
                objectid: contentItem.objectid,
              };
              contentItem.rentNowPriceModel = this.rentNowPriceModel;
            }

          // 3. FREE
          } else if (availability.pricemodel === "FREE") {
            contentItem.isDrmContent = true;
            contentItem.videoType = "Content";
            contentItem.playback_details = {
              packageid: packageDetails.packageid,
              availabilityid: availability.availabilityid,
              drmscheme: packageDetails.drmscheme?.[0],
              drmprovider: packageDetails?.drmprovider,
            };
            if (packageDetails?.[0]?.streamurl) {
              contentItem.streamUrl = packageDetails[0].streamurl;
            }
            return;
          }
        }

      } else if (!contentItem.hasOwnProperty("contentdetails")) {
        contentItem.isContentDetail = false;
      }
    },
    async playContent (content, contentIndex, isActiveStatus=false) {
      this.currentEpisode = content;
      if(content.playbacktype == 'LOCATORBASEDPLAYBACK') {
        this.redirectToLocator(this.currentEpisode);
        return;
      }
      if(content.playbacktype === "EXTERNALDEEPLINKURLBASEDPLAYBACK") {
          this.redirectToExternaldeeplinkurlbasedplayback(content);  
          return;  
      } 
      if (!this.isContentPlayableParentalLock(this.getCurrentProfile(), content.pgrating) && !isActiveStatus) {
        eventBus.$emit('event-parental-lock-CB',[content, contentIndex]);
        return;
      }
      let nextepisodeid = this.episodes[contentIndex + 1] ? this.episodes[contentIndex + 1].objectid : "";
      localStorage.setItem("nextepisodeid", nextepisodeid);
      this.episodePlayFromRoute = false;
      let fullPath = location.pathname.split("/");
      if (
        this.subscriberid &&
        this.episodes[contentIndex]?.isContentDetail &&
        this.episodes[contentIndex].hasOwnProperty("playback_details")
      ) {
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          // this.content.watchedTime = await this.getContentProgress(this.content);
          let uriData = null;
          const urlencoded = new URLSearchParams();
          if(isSafari) {
              uriData = await this.parseHlsManifest(this.episodes[contentIndex].streamUrl);
              if(uriData) {
                  urlencoded.append("keyid", uriData[0]);
                  urlencoded.append("keyiv", uriData[1]);
              }
          }
          urlencoded.append("contentid", this.episodes[contentIndex].objectid);
          urlencoded.append("ios", isSafari ? true : false);
          urlencoded.append("seclevel", "SW");
          let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
          Promise.all([drmPromise])
          .then(async ([drmRes]) => {
            if (drmRes?.data?.errorcode) {
              showSnackBar(this.$t(drmRes?.data?.reason), this.$t('DISMISS'));
              return;
            }
              let contentData = this.episodes[contentIndex];
              contentData['drmTokenResp'] = drmRes.data;
              eventBus.$emit("live-player-active", contentData);
          })
          .catch((err) => {
              console.log("err", err);
          });
      } else if (
        this.subscriberid &&
        content?.isContentDetail &&
        (this.subscriptions.length === 0 || this.subscriptions.length > 0) &&
        this.subscriberid !== this.profileid
      ) {

        eventBus.$emit("showAuthorizeErrorMessage", {
          state: true,
          messageData: {
            title: this.$t("Error"),
            message: this.$t("Sorry! Admin only allowed to the payment. Please contact your Admin"),
          },
        });
      }

      // User is logged in and has no subscription -- Master Profile
      else if (
        this.subscriberid &&
        content?.isContentDetail &&
        (this.subscriptions.length === 0 || this.subscriptions.length > 0)
      ) {
        this.setRegActiveDeeplink(true);

        //show subscribe popup.
        let payload = { listType: "onlySubscribe" };
        localStorage.setItem("payment_source", "Content Details");
          if (this.subscriberid !== this.profileid) {
              eventBus.$emit("showAuthorizeErrorMessage", {
              state: true,
              messageData: {
                title: this.$t("Error"),
                message: this.$t("Sorry! Admin only allowed to the payment. Please contact your Admin")
              },
            });
            return;
          }
          if (content.rentNowPriceModel) {
            eventBus.$emit("open-home-rzp-modal", content.rentNowPriceModel);
            return;
          }
    
        let currentLanguage = this.getCurrentLanguageUrlBase();
        this.redirectToPlans()
      } else if (this.subscriberid && !content?.isContentDetail) {
        //show snackbar component.
        eventBus.$emit("replace-content", content);
      } else {
        //open lookup popup.      
        let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
        localDisplayLang = localDisplayLang == 'eng' ? 'en' : localDisplayLang;
        this.redirectToLogin(localDisplayLang);
        // let payload = {
        //   state: true,
        //   formType: "lookup",
        // };
        // eventBus.$emit("authPopup", payload);
      }
    },

    extractThumbnailPoster(contentItem) {
      let posterKey = contentItem.poster;
      let thumbNailUrl = null;
      if (posterKey && Array.isArray(posterKey) == true && posterKey.length > 0) {
        // let posterFileList = posterKey[0].filelist;
        let posterFileList = posterKey?.find((posterKeyNode) => posterKeyNode.postertype == "LANDSCAPE")?.filelist;
        if (posterFileList && Array.isArray(posterFileList) == true && posterFileList.length > 0) {
          let thumbNailNode = posterFileList.find((posterNode) => posterNode.quality == "THUMBNAIL" || posterNode.quality == "SD" || posterNode.quality == "HD");
          if (thumbNailNode) {
            thumbNailUrl = thumbNailNode.filename;
          }
        }
      }
      return thumbNailUrl;
    },

  },
  components: {
    Loading: () => import(/* webpackChunkName: "Loading" */ "@/components/Templates/Loading.vue"),
    CustomSelect: () => import("@/components/utils/CustomSelect.vue"),
    Grid: () => import(/* webpackChunkName: "Grid" */ "@/components/Templates/GridLayout.vue"),
    EptyBin: () => import(/* webpackChunkName: "eptyBin" */ "@/components/SvgImages/Empty.vue"),
    GridLayoutPlaceholder: () => import(/* webpackChunkName: "gridplaceholder" */ "@/components/placeholders/GridLayoutPlaceholder.vue"),
  },
  beforeDestroy() {
    // eventBus.$off("send-episode-list");
    eventBus.$off("callAvailability");
    // eventBus.$off("season_listing_response");
  },
  mixins: [Utility, Redirection],
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
@import "@/components/Templates/Grid.scss";
#episodeListingContainer{
  margin-top: 0.8rem;
  .mainLayout {
    .content-container {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .gridMainLayout {
        .episodeCards {
          .gridCardWrapper {
            background: #242424;
          }
        }
      }
    }
  }

}
.mainLayoutSeason {
  // margin-right: 40px;
  //padding: 0 2rem;
  .select-ara {
    border: 1px solid $clr-light-gd1;
    width: 6%;
    padding: 0.4rem;
    margin: 0;
    margin-left: 0px;
    background: url("../../assets/icons/down_arrow.svg") no-repeat;
    -webkit-appearance: none;
    background-size: 12px;
    background-position-y: 54%;
    cursor: pointer;
    option {
      color: white;
    }
    #season-option {
      background: #161616;
    }
    &:focus {
      background-color: transparent;
    }
    background-position-x: 3%;
  }
  .select-eng {
    border: 1px solid $clr-light-gd1;
    width: 6rem;
    padding: 0.4rem;
    margin: 0;
    margin-left: 0px;
    background: url("../../assets/icons/down_arrow.svg") no-repeat;
    -webkit-appearance: none;
    background-size: 12px;
    background-position-y: 54%;
    cursor: pointer;
    option {
      color: white;
    }
    #season-option {
      background: #161616;
    }
    &:focus {
      background-color: transparent;
    }

    background-position-x: 92%;
  }
}
.play-img {
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    height: 36px !important;
    width: 36px !important;
    background: none !important;
  }
}
.loading {
  background: linear-gradient(to bottom left, #303030, #242424, #1d1d1d);
  border-radius: 8px;
  overflow: hidden;
}

@media screen and (max-width: 576px) {
  #episodeListingContainer {
    .mainLayoutSeason {
      padding: 0 !important;
      margin-bottom: 0.2rem;
    }
    .gridMainLayout {
      padding: 0 !important;
      .episodeCards {
        grid-template-columns: repeat(auto-fill, minmax(100%, 1fr)) !important;
        .gridCardWrapper {
          aspect-ratio: 16;
          background: #242424;
          .gridCardLayout {
            flex-direction: row;
            .gridPosterLayout {
              width: 30%;
            }
            .gridContentLayout {
              width: 70%;
              display: inline-block;
              padding: 0.3rem 0;
              .main-genre {
                display: none !important;
              }
              .gridDescription {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                padding: 0 0.8rem;
              }
            }

          }
        }
      }
    }
  }  
}
</style>
